import Box from "@mui/material/Box";
import ViewButton from "./ViewButton";

import checkIcon from "../../../assets/icons/check-circle.png";

export const getColumns = (t) => {
	return [
		{
			label: t("company_name_label"),
			name: "name",
		},
		{
			label: t("nip_label"),
			name: "nip",
		},
		{
			label: t("postal_code_label"),
			name: "postalCode",
		},
		{
			label: t("city_label"),
			name: "city",
		},
		{
			label: t("access"),
			name: "status",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value === "active") {
						return (
							<Box sx={{ height: "18px", width: "18px", margin: "0 auto" }}>
								<img
									style={{
										height: "100%",
										width: "100%",
										objectFit: "contain",
									}}
									src={checkIcon}
									alt=""
								/>
							</Box>
						);
					}

					return null;
				},
			},
		},
		{
			label: t("company_status_invoice_blocked"),
			name: "status",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value === "invoice_blocked") {
						return (
							<Box sx={{ height: "18px", width: "18px", margin: "0 auto" }}>
								<img
									style={{
										height: "100%",
										width: "100%",
										objectFit: "contain",
									}}
									src={checkIcon}
									alt=""
								/>
							</Box>
						);
					}

					return null;
				},
			},
		},
		{
			label: t("company_status_testing"),
			name: "status",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					if (value === "testing") {
						return (
							<Box sx={{ height: "18px", width: "18px", margin: "0 auto" }}>
								<img
									style={{
										height: "100%",
										width: "100%",
										objectFit: "contain",
									}}
									src={checkIcon}
									alt=""
								/>
							</Box>
						);
					}

					return null;
				},
			},
		},
		{
			label: t("status"),
			name: "source",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
						<span>{value === "register" ? "Rejestracja" : "Kontakt"}</span>
					);
				},
			},
		},
		{
			label: t("actions"),
			name: "id",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const rowData = tableMeta.rowData;
					const name = rowData[1];

					return (
						<Box sx={{ display: "flex", gap: "6px", justifyContent: "center" }}>
							<ViewButton companyId={value} />
						</Box>
					);
				},
			},
		},
	];
};

export const getOptions = (t) => {
	return {
		searchOpen: true,
		search: false,
		searchAlwaysOpen: true,
		searchPlaceholder: t("search"),
		selectableRows: "none",
		print: false,
		filter: false,
		download: true,
		viewColumns: false,
		rowsPerPageOptions: [10, 20, 50, 100],
		rowsPerPage: 20,
		textLabels: {
			pagination: {
				next: t("next_page"),
				previous: t("previous_page"),
				rowsPerPage: t("rows_per_page"),
				displayRows: t("of"),
			},
			toolbar: {
				search: t("search"),
				downloadCsv: t("download_csv"),
				print: t("print"),
				viewColumns: t("select_columns"),
				filterTable: t("filters"),
			},
			filter: {
				title: t("filters"),
				reset: t("reset"),
			},
			viewColumns: {
				title: t("show_columns"),
			},
			selectedRows: {
				text: t("removed_rows"),
				delete: t("remove"),
			},
			body: {
				noMatch: t("no_matching_data_found"),
			},
		},
	};
};
